import { render, staticRenderFns } from "./ChannelRow.vue?vue&type=template&id=367f1c44&"
import script from "./ChannelRow.vue?vue&type=script&lang=js&"
export * from "./ChannelRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports